// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__E7Dwj","title":"InfoRow_title__2CrqD"};